var r="4.10.0";export{r as version};
//# sourceMappingURL=package.json.js.map
